import { render, staticRenderFns } from "./PlotsRegulatory.vue?vue&type=template&id=5643cac2"
import script from "./PlotsRegulatory.vue?vue&type=script&lang=js"
export * from "./PlotsRegulatory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports